module.exports = __webpack_public_path__ + "media/styles/images/png/circle-left-bendy-arrow-teal-1acbf6773afe1dc7a4094406b881a470.png";